import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from 'react-router-dom';
import {
  Container,
  Button,
  Col,
  Row,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  getListAccount as onGetAccounts
} from "../../store/actions";

import {
  getCompanyById as onGetCompany,
  updateCompany as onUpdateCompany,
  addNewCompany as onAddCompany,
  getListAssetCategory as onGetAssetCategorys,
} from "../../store/actions";

import * as Yup from "yup";
import { useFormik } from "formik";

import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import * as url from "../../helpers/url_helper";
import { get as ClientGet } from "../../helpers/api_helper";
import { TableCell, TableHead, TableRow } from "@material-ui/core";

const CompanyCreateUpdate = (props) => {

  //meta title
  document.title = "Company | Des Counts";
  const id = props?.match?.params?.id;
  const isEdit = id != undefined;

  const { company, loading, accounts, loadingAccount, error } = useSelector(state => ({
    company: state.Company.company,
    loading: state.Company.loading,
    accounts: state.Account.listAccount,
    loadingAccount: state.Account.loading,
    error: state.Company.error,
  }));

  const [assetCategoryList, setAssetCategoryList] = useState(null);

  const { listAssetCategory, loadingAssetCategory } = useSelector(state => ({
    listAssetCategory: state.AssetCategory.listAssetCategory,
    loadingAssetCategory: state.AssetCategory.loading,
  }));

  const dispatch = useDispatch();
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: isEdit && company ? company.name : "",
      accountId: isEdit && company ? company.accountId : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Company Name"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        dispatch(onUpdateCompany({
          id: company.id, name: values.name, accountId: values.accountId, labelData: labelList,
          assetCategory: assetCategoryList.map(s => {
            return {
              id: s.id,
              companyId: s.companyId,
              accountIdCredit: s.accountIdCreditSelect == null || s.accountIdCreditSelect.length == 0 ? null : parseInt(s.accountIdCreditSelect.value),
              accountIdDebit: s.accountIdDebitSelect == null || s.accountIdDebitSelect.length == 0 ? null : parseInt(s.accountIdDebitSelect.value),
            }
          })
        }, props.history));
      } else {
        dispatch(onAddCompany({ name: values.name, labelData: labelList }, props.history));
      }
    },
  });

  const [labelList, setLabelList] = useState([]);

  const [selectedAccount, setSelectedAccount] = useState(null);
  const [optionAccount, setOptionAccount] = useState([]);
  function handleSelectAccount(e) {
    setSelectedAccount(e)
    console.log(e);
    validation.setFieldValue("accountId", e.value.toString(), true)
  }

  function handleSelectAccountAssetDep(e, id, t) {
    const newAssetCategoryList = assetCategoryList.map(item => {
      if (item.id !== id) {
        return item;
      }
      if (t === "credit") {
        return {
          ...item,
          accountIdCreditSelect: e
        };
      } else {
        return {
          ...item,
          accountIdDebitSelect: e
        };
      }
    });
    setAssetCategoryList(newAssetCategoryList);
  }

  const getLabelItemList = function () {
    ClientGet(url.GET_LABEL_ITEM_LIST, isEdit ? { companyId: id } : {}).then(res => {
      setLabelList(res.data);
    });
  }

  useEffect(() => {
    if (isEdit) {
      dispatch(onGetCompany({ id: id }));
      dispatch(onGetAssetCategorys({
        companyId: id,
      }));
    }
    getLabelItemList();
  }, [dispatch])

  useEffect(() => {
    if (company) {
      dispatch(onGetAccounts({ companyId: company.id }))
    }
  }, [company])

  useEffect(() => {
    if (accounts) {
      setOptionAccount(accounts.map((item) => {
        return { label: item.code + ' - ' + item.name, value: item.id.toString() }
      }))
    }
  }, [accounts])

  useEffect(() => {
    if (isEdit && company && accounts) {
      var account = optionAccount.filter(s => s.value == company.accountId)
      if (account.length > 0) {
        setSelectedAccount(account[0])
      }
      else {
        setSelectedAccount(null)
      }
    }
  }, [optionAccount])

  useEffect(() => {
    if (isEdit && listAssetCategory && optionAccount) {
      setAssetCategoryList(listAssetCategory.map(item => {
        return {
          ...item,
          accountIdCreditSelect: optionAccount.filter(s => s.value == item.accountIdCredit?.toString()),
          accountIdDebitSelect: optionAccount.filter(s => s.value == item.accountIdCredit?.toString())
        }
      }));
    }
  }, [listAssetCategory, optionAccount])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Master Data" breadcrumbItem={(isEdit ? "Edit" : "Add") + " Company"} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {
                    !loading &&
                    <>
                      <Row>
                        <Col>
                          <Form
                            className="form-horizontal"
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                          >
                            <Row>
                              <Col sm={12}>
                                <div className="mb-3">
                                  <Label className="form-label">Name</Label>
                                  <Input
                                    name="name"
                                    className="form-control"
                                    placeholder="Enter company name"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.name || ""}
                                    invalid={
                                      validation.touched.name && validation.errors.name ? true : false
                                    }
                                  />
                                  {validation.touched.name && validation.errors.name ? (
                                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                              {
                                isEdit &&
                                <Col sm={12}>
                                  <Label>Retained Earning's Account</Label>
                                  <div>
                                    <Select
                                      value={selectedAccount}
                                      onChange={handleSelectAccount}
                                      onBlur={validation.handleBlur}
                                      loading={loadingAccount}
                                      options={optionAccount}
                                      className="select2-selection"
                                      menuPosition="fixed"
                                    />
                                  </div>
                                </Col>
                              }
                            </Row>

                            {
                              isEdit &&
                              <Row className="mt-5">
                                <Col>
                                  <h5>Pengaturan Asset's Account Depreciation</h5>
                                </Col>
                              </Row>
                            }
                            {
                              isEdit && !loadingAssetCategory && assetCategoryList != null &&
                              <div className="table table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>Asset Category</th>
                                      <th>Account Credit</th>
                                      <th>Account Debit</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      assetCategoryList.length > 0 && assetCategoryList.map(item => {
                                        return <tr key={item.id}>
                                          <td className="align-middle">{item.name}</td>
                                          <td className="align-middle">
                                            <Select
                                              value={item.accountIdCreditSelect}
                                              onChange={(e) => handleSelectAccountAssetDep(e, item.id, "credit")}
                                              loading={loadingAccount}
                                              options={optionAccount}
                                              className="select2-selection"
                                              menuPosition="fixed"
                                            />
                                          </td>
                                          <td className="align-middle">
                                            <Select
                                              value={item.accountIdDebitSelect}
                                              onChange={(e) => handleSelectAccountAssetDep(e, item.id, "debit")}
                                              loading={loadingAccount}
                                              options={optionAccount}
                                              className="select2-selection"
                                              menuPosition="fixed"
                                            />
                                          </td>
                                        </tr>
                                      })
                                    }
                                    {
                                      assetCategoryList.length == 0 &&
                                      <tr>
                                        <td colSpan={3} className="text-center align-middle">No data available.</td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            }

                            <Row className="mt-5">
                              <Col>
                                <h5>Pengaturan Label Report</h5>
                              </Col>
                            </Row>
                            <hr className="mt-0" />
                            {
                              labelList.map(item => {
                                return <Row key={item.id} className="mt-2">
                                  <Col sm={6}>
                                    <div className="mb-3">
                                      <Label className="form-label">{item.alias} (Indonesia)</Label>
                                      <Input
                                        name={`${item.alias}id`}
                                        className="form-control"
                                        placeholder={`Masukkan ${item.alias}`}
                                        type="text"
                                        onChange={(e) => {
                                          item.value1 = e.target.value
                                          setLabelList(labelList)
                                        }}
                                        value={item.value1}
                                      />
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <div className="mb-3">
                                      <Label className="form-label">{item.alias} (English)</Label>
                                      <Input
                                        name={`${item.alias}en`}
                                        className="form-control"
                                        placeholder={`Enter ${item.alias}`}
                                        type="text"
                                        onChange={(e) => {
                                          item.value2 = e.target.value
                                          setLabelList(labelList)
                                        }}
                                        value={item.value2}
                                      />
                                    </div>
                                  </Col>
                                </Row>;
                              })
                            }

                            <div className="mt-3 mb-2">
                              <Link to="/masterdata/company">
                                <Button
                                  color="secondary"
                                  className="btn btn-secondary float-end"
                                >
                                  Cancel
                                </Button>
                              </Link>
                              <Button
                                color="primary"
                                className="btn btn-primary float-end me-2"
                                type="submit"
                              >
                                Submit
                              </Button>
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </>
                  }

                  {
                    loading &&
                    <div className="d-flex justify-content-center my-5">
                      <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                    </div>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

CompanyCreateUpdate.propTypes = {
  history: PropTypes.object,
};

export default withRouter(CompanyCreateUpdate)
